import { render, staticRenderFns } from "./PageVoucher.vue?vue&type=template&id=712d9d5a&scoped=true"
import script from "./PageVoucher.vue?vue&type=script&lang=js"
export * from "./PageVoucher.vue?vue&type=script&lang=js"
import style0 from "./PageVoucher.vue?vue&type=style&index=0&id=712d9d5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712d9d5a",
  null
  
)

export default component.exports